export default __webpack_public_path__ + "static/media/nifty-500-momentum-banner.e2491e42.png";